import { render } from "./radioInputsList.vue?vue&type=template&id=55c7140a"
import script from "./radioInputsList.vue?vue&type=script&lang=js"
export * from "./radioInputsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__